import Vue from 'vue'
import VueRouter from 'vue-router'

import LandingPageComponent from './pages/LandingPage'
import ForDoctorsComponent from './pages/ForDoctors'

const routes = [
    {
        path: '/',
        component: LandingPageComponent
    },
    {
        path: '/for-doctors',
        component: ForDoctorsComponent
    }
]

Vue.use(VueRouter)

const router = new VueRouter({
    routes
})

export default router